import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  outlineInput: {
    height: "40px",
    minWidth: "200px",
    paddingRight: 0,
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    width: "100%",
    lineHeight: "24px",
    borderRadius: "8px",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#308CDB",
    },
    "&:active .MuiOutlinedInput-notchedOutline": {
      borderColor: "#308CDB",
    },
  },
  filterButton: {
    backgroundColor: "#308CDB",
    borderRadius: "8px",
    height: "40px",
    padding: "10px",
    "& .MuiButton-startIcon": {
      marginLeft: 0,
    },
    "&:hover": {
      backgroundColor: "#369CF3",
    },
    "&:active": {
      backgroundColor: "#03569E",
    },
  },
  textButton: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "15px",
    color: "#FFFFFF",
    fontStyle: "normal",
  },
  menuHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "16px 16px 0 16px",
  },
  textHeader: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "28px",
    color: "#344054",
  },
  list: {
    paddingBottom: "16px",
  },
  iconSearchButton: {
    padding: "5px",
  },
  menu: {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    border: "1px solid #DEDEDE",
    width: "300px",
    marginTop: "45px",
  },
}));

export default styles;
